import { format, parse } from 'date-fns'
// NOTE: I would much rather write a React component, but we would need to rewrite `grid_controller.js` to use React.
// For now, we have to build custom classes manually like this. This is a simple case but if we need more compelx logic
// we should make the switch to React. -NG

export default class {
  init(params) {
    const parsedDate = parse(params.displayName, 'M/d/yyyy', new Date())
    const { shortFormat, longFormat } = this._formatDay(parsedDate, params.dateIndex)
    const displayText = document.createElement('span')
    displayText.ariaHidden = true
    displayText.innerHTML = shortFormat

    const accesibleText = document.createElement('span')
    accesibleText.classList.add('visually-hidden')
    accesibleText.innerHTML = longFormat

    this.eGui = document.createElement('span')
    this.eGui.appendChild(displayText)
    this.eGui.appendChild(accesibleText)
  }

  getGui() {
    return this.eGui
  }

  _formatDay(day, i) {
    const dayShort = format(day, 'EEEEEE')
    const dayLong = format(day, 'EEEE')

    const formattedDayShort = ['Tu', 'Th', 'Sa', 'Su'].includes(dayShort) ? dayShort : dayShort[0]

    return {
      shortFormat: `${formattedDayShort} (${i})`,
      longFormat: `${dayLong} (${i})`
    }
  }
}
